import Link from 'next/link';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useLocale } from 'shared/hooks/useLocale';
import { getSanityLinkUrl } from 'shared/utils/getSanityLinkUrl';
import styles from './styles.module.scss';
import { FooterMenuLinkProps } from './types';

const FooterMenuLink = ({ link, label }: FooterMenuLinkProps) => {
  const locale = useLocale();
  const linkUrl = getSanityLinkUrl(link, locale) || '';
  const isExternal = linkUrl.startsWith('http');
  const isAnchor = linkUrl.startsWith('#');
  const router = useRouter();
  const currentPath = router.asPath.split('#')[0];

  const href = useMemo(() => {
    if (isAnchor) {
      return `${currentPath}${linkUrl}`;
    }
    if (isExternal) {
      return linkUrl;
    }
    return `/${linkUrl}`.replace(/\/+/g, '/');
  }, [currentPath, isAnchor, isExternal, linkUrl]);

  return (
    <Link href={href} className={styles.link}>
      {label}
    </Link>
  );
};

export default FooterMenuLink;
